// extracted by mini-css-extract-plugin
export var bottomborder = "IntroSponsorDogProfile-module--bottomborder--89771";
export var bottombordersection = "IntroSponsorDogProfile-module--bottombordersection--5430a";
export var dogdetails = "IntroSponsorDogProfile-module--dogdetails--0123d";
export var sadprofilecontainer = "IntroSponsorDogProfile-module--sadprofilecontainer--8c0df";